import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  _get_referral_dashboard,
  _get_referral_income_history,
  _get_referral_pool,
  _get_ambassador_dashboard,
  _get_profile,
} from "../common/axios_services";
import { profileData, setUserData } from "../slices/profileSlice";
import { showErrorNotification } from "../common/utils/notification";

const INCOME_TYPES = [
  { key: "", label: "All" },
  { key: "REFERRAL_INCOME", label: "Referral income" },
  { key: "TOPEATER_INCOME", label: "My cashback" },
  { key: "SALES_INCOME", label: "Sales income" },
];

const useReferralData = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dashboard, setDashboard] = useState({});
  const [incomeHistory, setIncomeHistory] = useState([]);
  const [incomeHistoryMeta, setIncomeHistoryMeta] = useState({});
  const userData = useSelector((state) => state.userProfile.dataFetched);
  const [referralPool, setReferralPool] = useState(false);
  const [loading, setLoading] = useState(true);
  const [incomeLoading, setIncomeLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [incomeTypeFilter, setIncomeTypeFilter] = useState("");

  const fetchUserProfile = async () => {
    try {
      const response = await _get_profile();
      const uData = response?.data?.data;
      dispatch(setUserData(uData));
      dispatch(profileData(uData));
    } catch (err) {
      console.error("Failed to load user profile in referral hook:", err);
    }
  };

  const fetchDashboard = async () => {
    try {
      const res = userData?.isAmbassador
        ? await _get_ambassador_dashboard()
        : await _get_referral_dashboard();
      const data = res.data.data?.data || res?.data?.data;
      setDashboard(data);
    } catch (err) {
      handleError(err);
    }
  };

  const fetchIncomeHistory = async (pg, type) => {
    try {
      setIncomeLoading(true);
      const res = await _get_referral_income_history(pg, pageSize, type);
      const responseData = res.data.data || res.data;
      setIncomeHistory(responseData.data || []);
      setIncomeHistoryMeta(responseData.meta || {});
    } catch (err) {
      handleError(err);
    } finally {
      setIncomeLoading(false);
    }
  };

  const fetchReferralPool = async () => {
    try {
      const referral_pool = await _get_referral_pool();
      setReferralPool(referral_pool.data.data || referral_pool.data || []);
    } catch (err) {
      handleError(err);
    }
  };

  const handleError = (err) => {
    if (err.response) {
      if (err.response.data.message === "Unauthorized") {
        localStorage.removeItem("konnect_token");
        navigate("/signin");
      }
      showErrorNotification(err.response.data.message);
    } else {
      showErrorNotification(err.message);
    }
  };

  useEffect(() => {
    Promise.all([
      fetchUserProfile(),
      fetchDashboard(),
      fetchIncomeHistory(1, ""),
      fetchReferralPool(),
    ]).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchIncomeHistory(page, incomeTypeFilter);
  }, [page, incomeTypeFilter]);

  return {
    dashboard,
    incomeHistory,
    incomeHistoryMeta,
    userData,
    referralPool,
    loading,
    incomeLoading,
    page,
    setPage,
    pageSize,
    setPageSize,
    incomeTypeFilter,
    setIncomeTypeFilter,
    INCOME_TYPES,
  };
};

export default useReferralData;
